import { useState } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { router } from '@inertiajs/react';
import { CloseIcon } from '../../assets/icons/icons';
import SatisfactionScale from './SatisfactionScale';
import RatesModal from './RatesModal';

export default function Rates({ onDismiss }) {
  const [rating, setRating] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const handleSubmit = () => {
    if (rating === 0) return;
    router.post('/surveys', {
      survey: { type: 'RateComparisonSurvey', data: { rating, page: window.location.pathname } },
    }, { preserveState: true, preserveScroll: true });
    onDismiss();
  };

  const handleModalSubmit = (data) => {
    router.post('/surveys', {
      survey: { type: 'RateComparisonSurvey', data: { ...data, page: window.location.pathname } },
    }, { preserveState: true, preserveScroll: true });
    setModalOpen(false);
    onDismiss();
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: 'common.white',
          boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
          zIndex: 1300,
          py: 2,
          px: 3,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-evenly"
          gap={1}
          flexWrap="wrap"
        >
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <Typography variant="body1" sx={{ minWidth: 200, maxWidth: 280 }}>
              What is your overall satisfaction with the SVCE Rate Comparison Tool?
            </Typography>
            <IconButton onClick={onDismiss} aria-label="Close survey" size="small" sx={{ display: { sm: 'none' } }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <SatisfactionScale value={rating} onChange={setRating} />

          <Box display="flex" alignItems="center" gap={2}>
            <Button
              variant="outlined"
              color="svceGreen"
              onClick={handleSubmit}
              disabled={rating === 0}
              sx={{
                fontWeight: 600,
                textTransform: 'uppercase',
                borderRadius: '4px',
                px: 3,
              }}
            >
              Submit
            </Button>

            <Button
              onClick={() => setModalOpen(true)}
              sx={{
                color: 'primary.main',
                fontWeight: 600,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                whiteSpace: 'nowrap',
              }}
            >
              More Feedback?
            </Button>

            <IconButton onClick={onDismiss} aria-label="Close survey" size="small" sx={{ display: { xs: 'none', sm: 'flex' } }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <RatesModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleModalSubmit}
        initialRating={rating}
      />
    </>
  );
}
